export const faqs = [
  {
    id: 'faq-1',
    question: '蘑菇社区是什么？适合哪些人加入？',
    answer: '蘑菇社区是一个以兴趣爱好为核心的线上交流平台，汇聚了旅行、美食、科技、读书、健身、艺术等多元领域的优质内容与真实用户。无论你是想分享自己的经验、发现新鲜有趣的资讯，还是寻找志同道合的朋友，蘑菇社区都欢迎你的加入。我们的用户涵盖从大学生到职场人士的广泛群体，每个人都能在这里找到属于自己的兴趣圈子。',
  },
  {
    id: 'faq-2',
    question: '如何加入蘑菇社区？需要付费吗？',
    answer: '加入蘑菇社区非常简单！你只需要在官网点击"立即加入"按钮，填写基本的注册信息即可完成注册。蘑菇社区的所有核心功能完全免费，包括浏览文章、加入兴趣圈子、参与讨论等。我们致力于为每一个热爱生活的人提供一个温暖有趣的交流空间。',
  },
  {
    id: 'faq-3',
    question: '蘑菇社区有哪些兴趣圈子可以选择？',
    answer: '蘑菇社区目前设有六大核心兴趣圈子：旅行探险、美食烹饪、数码科技、读书思考、运动健身和艺术创作。每个圈子都有专属的内容板块和活跃的用户群体。我们会根据社区的发展情况和用户需求，持续拓展新的兴趣领域，确保每个人都能找到自己感兴趣的内容。',
  },
  {
    id: 'faq-4',
    question: '如何在蘑菇社区发布内容？',
    answer: '注册成为蘑菇社区用户后，你可以进入任意兴趣圈子，点击"发布文章"按钮来分享你的经验、心得或创作。我们支持富文本编辑，可以插入图片和视频。发布的内容会经过社区的审核流程，确保社区内容的质量。优质的原创内容还有机会被推荐到首页，获得更多曝光和互动。',
  },
  {
    id: 'faq-5',
    question: '蘑菇社区的内容质量如何保证？',
    answer: '蘑菇社区非常重视内容质量。我们建立了一套完善的内容审核机制：所有用户发布的内容都会经过自动化审核和人工复核，确保内容原创、真实、有价值。同时，社区的点赞、评论和举报机制让优质内容能够被更多人看到，低质量内容也会被及时处理。我们鼓励深度、有见地的分享，而非浅薄的流量内容。',
  },
  {
    id: 'faq-6',
    question: '蘑菇社区有移动端应用吗？',
    answer: '目前蘑菇社区的移动端应用正在紧锣密鼓地开发中，预计将在近期上线。在此之前，我们的网站已经做了全面的移动端适配，你可以通过手机浏览器访问蘑菇社区官网，获得流畅的浏览和互动体验。移动端应用的推出将带来更便捷的使用体验和更多专属功能，敬请期待。',
  },
];